<template>
  <LoadingItem v-if="loading" />
  <div class="period-wrap">
    <div class="period-header">
      <select v-model="searchQuery.type">
        <option value="day">날짜별</option>
        <option value="month">월별</option>
      </select>
      <span>기간조회 :</span>
      <DatePic
        v-model:value="searchQuery.from"
        format="YYYY-MM-DD"
        value-type="format"
      />
      <span style="margin: 0 3px">~</span>
      <DatePic
        v-model:value="searchQuery.to"
        format="YYYY-MM-DD"
        value-type="format"
      />
      <button @click="getList()">검색</button>
    </div>
    <!-- period-header -->
    <table class="border-tb" style="margin-top: 1px">
      <tr>
        <th v-for="(e, i) in titleArr" :key="i">{{ e }}</th>
      </tr>
      <tr v-for="(e, i) in list" :key="i">
        <td>{{ e.date }}</td>
        <td>{{ $addCommas(e.deposit_amount) }}</td>
        <td>{{ $addCommas(e.withdrawal_amount) }}</td>
        <td>{{ $addCommas(e.deposit_amount - e.withdrawal_amount) }}</td>
        <td>{{ $addCommas(e.give_money_amount) }}</td>
        <td>{{ $addCommas(e.give_point_amount) }}</td>
        <td>{{ $addCommas(e.money_bet_amount) }}</td>
        <td>{{ $addCommas(e.point_bet_amount) }}</td>
        <td>{{ $addCommas(e.money_bet_amount + e.point_bet_amount) }}</td>
        <td>{{ $addCommas(e.money_cancel_amount) }}</td>
        <td>{{ $addCommas(e.point_cancel_amount) }}</td>
        <td>{{ $addCommas(e.money_cancel_amount + e.point_cancel_amount) }}</td>
        <td>{{ $addCommas(e.win_amount) }}</td>
        <td>
          {{
            $addCommas(e.money_bet_amount + e.point_bet_amount - e.win_amount)
          }}
        </td>
      </tr>
      <!-- 총 합계 -->
      <tr v-if="list.length != 0" style="background-color: #edeaea">
        <td></td>
        <td>{{ $addCommas(total.deposit_amount) }}</td>
        <td>{{ $addCommas(total.withdrawal_amount) }}</td>
        <td>{{ $addCommas(total.transaction) }}</td>
        <td>{{ $addCommas(total.give_money_amount) }}</td>
        <td>{{ $addCommas(total.give_point_amount) }}</td>
        <td>{{ $addCommas(total.money_bet_amount) }}</td>
        <td>{{ $addCommas(total.point_bet_amount) }}</td>
        <td>{{ $addCommas(total.bet_amount) }}</td>
        <td>{{ $addCommas(total.money_cancel_amount) }}</td>
        <td>{{ $addCommas(total.point_cancel_amount) }}</td>
        <td>{{ $addCommas(total.cancel_amount) }}</td>
        <td>{{ $addCommas(total.win_amount) }}</td>
        <td>{{ $addCommas(total.profit_loss) }}</td>
      </tr>
    </table>
  </div>
  <!-- period-wrap -->
</template>

<script>
export default {
  data() {
    return {
      titleArr: [
        "날짜",
        "충전금액",
        "환전금액",
        "충/환손익금액",
        "임의지급머니",
        "임의지급포인트",
        "보유머니배팅금액",
        "포인트머니배팅금액",
        "총배팅금액",
        "보유머니환불금액",
        "포인트머니환불금액",
        "환불금액합계",
        "총적중금액",
        "총배팅손익금액",
      ],
      total: {
        deposit_amount: 0,
        withdrawal_amount: 0,
        transaction: 0,
        give_money_amount: 0,
        give_point_amount: 0,
        money_bet_amount: 0,
        point_bet_amount: 0,
        bet_amount: 0,
        money_cancel_amount: 0,
        point_cancel_amount: 0,
        cancel_amount: 0,
        win_amount: 0,
        profit_loss: 0,
      },
      list: [],
      loading: false,
      searchQuery: {
        type: "day",
        partnerUuid: this.$route.query.pid ? this.$route.query.pid : "",
        from: this.$moment().subtract(7, "days").format("YYYY-MM-DD"),
        to: this.$moment().format("YYYY-MM-DD"),
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //리스트
    getList() {
      this.loading = true;
      this.$axios
        .get(`statistic/period?${this.$qs.stringify(this.searchQuery)}`)
        .then((res) => {
          this.list = res.data;
          this.totalInit();
          this.totalCalc();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //토탈 계산기
    totalCalc() {
      this.list.forEach((e) => {
        this.total.deposit_amount += e.deposit_amount;
        this.total.withdrawal_amount += e.withdrawal_amount;
        this.total.transaction += e.deposit_amount - e.withdrawal_amount;
        this.total.give_money_amount += e.give_money_amount;
        this.total.give_point_amount += e.give_point_amount;
        this.total.money_bet_amount += e.money_bet_amount;
        this.total.point_bet_amount += e.point_bet_amount;
        this.total.bet_amount += e.money_bet_amount + e.point_bet_amount;
        this.total.money_cancel_amount += e.money_cancel_amount;
        this.total.point_cancel_amount += e.point_cancel_amount;
        this.total.cancel_amount +=
          e.money_cancel_amount + e.point_cancel_amount;
        this.total.win_amount += e.win_amount;
        this.total.profit_loss +=
          e.money_bet_amount + e.point_bet_amount - e.win_amount;
      });
    },
    //토탈 초기화
    totalInit() {
      for (let key in this.total) {
        this.total[key] = 0;
      }
    },
  },
};
</script>
